// @flow
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import Error404 from '.';

const Error404Container = compose(injectIntl)(Error404);

Error404Container.displayName = 'Error404Container';

export default Error404Container;



// WEBPACK FOOTER //
// ./app/Error/components/Error404/container.js